export default __webpack_public_path__ + "static/media/handShake.54c217fb.svg";